import { Api } from 'helper/api/base';
import { ApiClient } from 'helper/api/client';

export class ApiFactory {
  auth: string;
  baseUrl: string;
  timeout: number;

  constructor(baseUrl: string, clientId: string, clientSecret: string, timeout = 10000) {
    this.auth = btoa(`${clientId}:${clientSecret}`);
    this.baseUrl = baseUrl;
    this.timeout = timeout;
  }

  build() {
    return new ApiClient(
      new Api(this.baseUrl, this.timeout),
      this.auth
    ).withOAuth();
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/api/factory.ts